import React, { useLayoutEffect, useRef } from "react";
import { useEffect, useState, useMemo } from "react";
import Icons from "../../../global/constants/icons.ts";
import {
  TextField,
  Box,
  FormControl,
  InputAdornment,
  Autocomplete,
  Popover,
  IconButton,
  Dialog,
  Typography,
  Button,
  colors,
  Tooltip,
  Checkbox,
  DialogContent,
  SvgIcon,
  Grid,
} from "@mui/material";
import {
  ApiGetAllocations,
  ApiGetVenueList,
  ApiGetClientEntityByClientGroupId,
  ApiGetShopperPopUpDetails,
  ApiEditorClientEntities,
  ApiEditorVenueList,
  ApiGetAdminMonthlyAllocations,
  ApiPutShopperDetails,
  ApiReportTempToken,
  ApiResetBulkAllocation,
  ApiChangeApproveAllocationsDate,
  ApiUpdateEarlyInvoice,
} from "../../../apiService/Core/Apicall.tsx";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../../../global/config/store.ts";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { toast } from "react-toastify";
import Dcrage from "../OrphanAllocation/Dcrage.tsx";
import { useNavigate } from "react-router-dom";
import new_orange from '../../../assets/images/neworange.png'
import new_green from '../../../assets/images/newgreen.png'
import { AttachMoneyOutlined, Cancel, CancelOutlined, Clear, FilterAltOffOutlined, FilterAltOutlined, MoneyOffOutlined, Note, PersonOutlined, ReportProblem, ReportProblemOutlined } from '@mui/icons-material';
import { Edit } from "lucide-react";
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts";
import mmlogo from '../../../assets/images/MM_logo.png'
import aldilogo from '../../../assets/images/Aldi_logo.png'
import bloomslogo from '../../../assets/images/Blooms_logo.png'
import clogo from '../../../assets/images/c-logo.png'
import venueclose from '../../../assets/images/veneu-close.png'
import venuemessage from '../../../assets/images/venuemessage.png'
import liqur from '../../../assets/images/liqur-glass.png'
import store from "../../../global/config/store.ts";
import { setLoadingFalse, setLoadingTrue } from "../../../global/config/Action/loadingActions.ts";
import dayjs, { Dayjs } from "dayjs";
import { DateCalendar } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useShopperDetails } from "../../../global/ShopperDetailsUtils.ts"
import { setDate } from "../../../global/config/Reducer/dateSlice.ts";
import { number } from "yup";

function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debouncedValue;
}

const MonthlyCalendar: React.FC = () => {
  const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
  const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
  const dispatch = useDispatch()
  const [search, setSearch] = useState("");
  const [clientEntityList, setClientEntityList] = useState<any>([]);
  const [clientEntityId, setClientEntityId] = useState<string | null>(null);
  const [venueName, setVenueName] = useState([]);
  const [venueNameValue, setVenueNameValue] = useState<any>(null);
  const [allocations, setAllocations] = useState([]);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date(selectedDateRedux));
  const Clientlist = useSelector((state: RootState) => state.client.clientList);
  const [selectedClient, setSelectedClient] = useState<any>(selectedClientName);
  const [ClientId, setClientId] = useState(null);
  // const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  // const [loanData, setLoanData] = useState();
  const [showNotes, setshowNotes] = useState<boolean>(false);
  const [selectedShopper, setSelectedShopper] = useState('');
  const [selectedNotes, setselectedNotes] = useState<number>();
  const navigate = useNavigate()
  const [fullText, setFullText] = useState('');
  const [fullText2, setFullText2] = useState('');
  const [staticLineInserted, setStaticLineInserted] = useState(false);
  const [staticLineInserted2, setStaticLineInserted2] = useState(false);
  const shoppernoteRef = useRef<HTMLTextAreaElement | null>(null);
  const trainingnoteRef = useRef<HTMLTextAreaElement | null>(null);
  const userRole: any = localStorage.getItem("userRoleName");
  const userId: any = localStorage.getItem("userId");
  const { anchorEl, loanData, clickedShopperId, handleShopperDetailsClick, handleClose } = useShopperDetails();
  const [isStartLoading, setisStartLoading] = useState(false);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [index, setIndex] = useState<number>();
  const [selectedAllocations, setSelectedAllocations] = useState<number[]>([]);
  const [open, setOpen] = useState(false);
  const [selectedNewDate, setSelectedNewDate] = useState<Dayjs | null>();
  const userName = localStorage.getItem('userName') || ""
  const [OutsideMonthEvents, setOutsideMonthEvents] = useState<any>([]);
  const isSpecialClient = selectedClientName?.clientGroupName === "ALDI";
  const [regions, setRegions] = useState<any[]>([])
  const [selectedRegion, setSelectedRegion] = useState<any>();
  const notesRef = useRef<HTMLDivElement | null>(null);
  const [openLeft, setOpenLeft] = useState<boolean | null>(null);


  useLayoutEffect(() => {
    if (notesRef.current) {
      const rect = notesRef.current.getBoundingClientRect();
      const screenWidth = window.innerWidth;
      if (rect.right > screenWidth) {
        setOpenLeft(true);
      } else {
        setOpenLeft(false);
      }
    }
  }, [showNotes]);


  useEffect(() => {
    if (Clientlist.length > 2) {
      // setSelectedClient(Clientlist[2]);
      setClientId(Clientlist[2].clientGroupName);
    }
  }, [Clientlist]);

  useEffect(() => {
    if (selectedDateRedux) {
      setSelectedDate(new Date(selectedDateRedux))
    }
  }, [selectedDateRedux])

  useEffect(() => {
    setSelectedClient(selectedClientName)
  }, [selectedClientName])

  const debouncedClientEntityId = useDebounce(clientEntityId, 500);
  const debouncedVenue = useDebounce(venueNameValue, 700);

  const monthDays = useMemo(() => {
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    return Array.from({ length: daysInMonth }, (_, i) => {
      const date = new Date(year, month, i + 1);
      return {
        fullDate: date.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
        }),
        weekday: date.toLocaleDateString("en-US", { weekday: "long" }),
        isoDate: date.toISOString(),
        month: date.toLocaleDateString("en-US", { month: "short" }),
        dayOfMonth: i + 1,
      };
    });
  }, [selectedDate]);

  useEffect(() => {
    // Only fetch client list on initial load
    handleGetClientList();
    // We'll handle allocation fetching in a separate effect
  }, []);

  // Add a new useEffect that will run when selectedClient is set initially
  // useEffect(() => {
  //   if (selectedClient) {
  //     handleGetAllocation();
  //   }
  // }, [selectedClient, clientEntityId]);

  useEffect(() => {
    if (debouncedClientEntityId && userRole !== "Editor") {
      ApiCallGetVenueList(debouncedClientEntityId);
    } else if (debouncedClientEntityId && userRole == "Editor") {
      const venueList = clientEntityList.find(
        (option: any) => option?.clientEntityId === clientEntityId
      )?.venues || []
      const response = venueList?.map((item: any) => ({
        label: item.venueName,
        value: item.venueId,
      }));
      setVenueName(response)
    } else {
      setVenueName([]);
      setVenueNameValue(null);
    }
  }, [debouncedClientEntityId]);

  useEffect(() => {
    if (clientEntityId === null) {
      setVenueName([]);
    }
  }, [clientEntityId]);

  // useEffect(() => {
  //   handleGetClientList();
  // }, [ClientId]);

  useEffect(() => {
    if (selectedClient && selectedClient.clientGroupName !== "All") {
      handleGetClientList();
    }
  }, [selectedClient]);

  useEffect(() => {
    if (selectedClient && selectedClient) {
      // Only call if selectedClient exists
      const timeout = setTimeout(() => {
        handleGetAllocation();
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [debouncedVenue, selectedDate, selectedClient]);

  useEffect(() => {
    if (clientEntityId) {
      handleGetAllocation();
    }
  }, [clientEntityId, selectedRegion]);

  // const handleHover = async (event, index, item?: any) => {
  //   setAnchorEl(event.currentTarget);
  //   // Store the hovered row index
  //   try {
  //     const currentDate = new Date();
  //     const currentMonth = currentDate.getMonth() + 1; // Months are zero-based, so add 1
  //     const currentYear = currentDate.getFullYear();

  //     const data = `?userId=${item?.appliedData?.userId}&currentMonth=${currentMonth}&currentYear=${currentYear}`;

  //     // Call API to get shopper details
  //     const response = await ApiGetShopperPopUpDetails(data);

  //     if (!response.status) {
  //       toast.error("Failed to load shopper details");
  //       return;
  //     }

  //     // Set shopper details from API response
  //     setLoanData(response.data);
  //     setSelectedIndex(index);
  //   } catch (error) {
  //     //toast.error("Error loading shopper details");
  //   }
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  //   setSelectedIndex(null);
  // };

  const handleGetAllocation = async () => {
    setisStartLoading(true)
    store.dispatch(setLoadingTrue());
    const venueList = clientEntityList.find(
      (option: any) => option?.clientEntityId === clientEntityId
    )?.venues || []
    const finalData = venueList?.map((item: any) => item.venueId)
    console.log('Final Data', finalData)
    const jobMonth = selectedDate.getMonth() + 1; // +1 because getMonth() returns 0-11
    const jobYear = selectedDate.getFullYear();

    let data = `?offset=0&limit=100&jobMonth=${jobMonth}&jobYear=${jobYear}`;
    if (venueNameValue) data += `&venueId=${venueNameValue}`;
    if (clientEntityId) data += `&clientEntityId=${clientEntityId}`;
    if (selectedClient?.clientGroupName !== 'All')
      data += `&allocationClientGroup=${selectedClient.clientGroupName}`;
    if (selectedRegion?.value) data += `&regionId=${selectedRegion?.value}`
    if (userRole === "Editor") data += `&editorId=${userId}`

    try {

      const res: any = await ApiGetAdminMonthlyAllocations(data);
      if (res.success) {
        setAllocations(res.data);
        setisStartLoading(false)
        const outsideMonthEvents = res?.data?.filter((allocation: any) =>
          dayjs(allocation?.selectedVisitDate).month() !== dayjs(selectedDate).month() &&
          allocation?.allocationStatusName !== "Completed"
        );
        setOutsideMonthEvents(outsideMonthEvents)

      }
    } catch (error) {
      const message =
        error?.response?.data?.message || // API error message
        error?.message ||                 // JS error message
        String(error);
      toast.error(message)
      console.error("Error during API call:", error);
      setisStartLoading(false)

    }
    finally {
      // store.dispatch(setLoadingFalse())
    }
  };

  console.log("CLient Venue List", venueName)
  const handleGetClientList = async () => {
    if (!selectedClient || selectedClient.clientGroupName === "All") return;
    const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`;
    const data2 = `?editorId=${userId}&clientGroupName=${selectedClientName?.clientGroupName}`;

    try {
      const res: any = userRole == 'Editor' ? await ApiEditorClientEntities(data2) : await ApiGetClientEntityByClientGroupId(data);
      setClientEntityList(res.data);
      // if (isSpecialClient) {
      //   const fullBusinessData = res?.data || [];

      //   const response = fullBusinessData
      //     .filter((item: any) => item && item.entityName && item.clientEntityId)
      //     .map((item: any) => ({
      //       label: item.entityName,
      //       value: item.clientEntityId,
      //       regions: item.regions || []
      //     }));
      //   if (response[0].regions && response[0].regions.length > 0) {
      //     const regionOptions = response[0].regions.map((region: any) => ({
      //       label: region.regionName,
      //       value: region.regionId
      //     }));
      //     setRegions(regionOptions);
      //     const regionToSet = regionOptions[0];
      //     setSelectedRegion(regionToSet);
      //   }
      // }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleBusinessChange = (event: any, newValue: any) => {
    setClientEntityId(newValue?.clientEntityId || null);
    setSelectedRegion(null)
    setRegions([]);
    if (!newValue) {
      setVenueNameValue(null);
      setRegions([]);
      setSelectedRegion(null);
    } else if (isSpecialClient && newValue?.regions) {
      const regionOptions = newValue.regions.map((region: any) => ({
        label: region.regionName,
        value: region.regionId
      }));
      setRegions(regionOptions);
      setSelectedRegion(null);
    } else {
      setRegions([]);
      setSelectedRegion(null);
    }
  }

  const ApiCallGetVenueList = async (debouncedClientEntityId: string) => {
    const data = `?clientEntityId=${clientEntityId}&offset=0&limit=500&venueStatus=active`;
    const data2 = `?clientEntityId=${clientEntityId}&editorId=${userId}`;
    try {
      const res = userRole == 'Editor' ? await ApiEditorVenueList(data2) : await ApiGetVenueList(data);
      const response = res?.data.map((item) => ({
        label: item.venueName,
        value: item.venueId,
      }));
      setVenueName(response);
    } catch (error) {
      console.error("Error fetching venue list:", error);
    }
  };
  console.log("ALLOCATION", allocations);


  const handleOnFocus = (e) => {

    if (!staticLineInserted) {
      e.preventDefault(); // prevent newline from default action
      // const now = new Date();
      // const formatted = now.toLocaleString(); // e.g., 7/14/2025, 12:35:10 PM
      const now = new Date();

      const day = String(now.getDate()).padStart(2, "0");
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = now.getFullYear();

      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 ⇒ 12

      const formatted = `${day}/${month}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
      const staticLine = `${userName}-${formatted}\n`;
      const updatedText = `${staticLine}\n${fullText?.length > 1 ? `${fullText}\n` : ""}`; // add static line
      setFullText(updatedText);
      setStaticLineInserted(true);

      setTimeout(() => {
        const textarea = shoppernoteRef && shoppernoteRef.current;
        if (textarea) {
          textarea.focus(); // ensure focus
          textarea.setSelectionRange(staticLine.length, staticLine.length);
        }
      }, 0);

    }
  };
  const handleOnFocus2 = (e) => {

    if (!staticLineInserted2) {
      e.preventDefault(); // prevent newline from default action
      // const now = new Date();
      // const formatted = now.toLocaleString(); // e.g., 7/14/2025, 12:35:10 PM

      const now = new Date();

      const day = String(now.getDate()).padStart(2, "0");
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = now.getFullYear();

      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 ⇒ 12

      const formatted = `${day}/${month}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
      const staticLine = `${userName}-${formatted}:\n`;
      const updatedText = `${staticLine}\n${fullText2?.length > 1 ? `${fullText2}\n` : ""}`; // add static line
      setFullText2(updatedText);
      setStaticLineInserted2(true);

      setTimeout(() => {
        const textarea = trainingnoteRef && trainingnoteRef.current;
        if (textarea) {
          textarea.focus(); // ensure focus
          textarea.setSelectionRange(staticLine.length, staticLine.length);
        }
      }, 0);

    }
  };



  const handleChange = (e) => {
    setFullText(e.target.value);
  };
  const handleOpenNotes = (allocation) => {
    allocation?.shopperNotes !== null ? setFullText(allocation?.shopperNotes) : setFullText('');
    allocation?.trainingNotes !== null ? setFullText2(allocation?.trainingNotes) : setFullText2('');
    setStaticLineInserted(false);
    setStaticLineInserted2(false);
    setSelectedShopper(allocation.shopperName)
    setshowNotes(true);
    setselectedNotes(allocation.allocationId)
  }

  const handleChangetraining = (e) => {
    setFullText2(e.target.value);
  };

  const handleEditScoreCard = (allocationId: any) => {
    navigate(`/createOrEditScoreCard/${allocationId}`, {
      state: { clientGroup: ClientId },
    });
  }
  const saveNotes = async (userId: any) => {
    try {
      const data = {
        userId: userId,
        shopperNotes: fullText,
        trainingNotes: fullText2,
      };
      const response = await ApiPutShopperDetails(data);

      toast.success("Shopper notes saved successfully");
      setshowNotes(false)
      await handleGetAllocation()
      setFullText('')
      setFullText2('')
    } catch (error) {
      console.error("Error saving shopper notes:", error);
      toast.error("Error saving shopper notes");
    }
  };

  const handleAllocationClick = (allocationId: string, status: any) => {
    const selectedMonth = selectedDate.getMonth() + 1; // 1-12
    const selectedYear = selectedDate.getFullYear();

    // navigate(`/admin/allocation-details/${allocationId}`, {
    //   state: {
    //     forcedDate: selectedDate,
    //     isApproved: true,
    //     allocationStatus: status
    //   },
    // });
    const state = {
      forcedDate: selectedDate,
      isApproved: true,
      allocationStatus: status,
    };

    sessionStorage.setItem('allocationDetailsState', JSON.stringify(state));
    localStorage.getItem("userRoleName") === "Editor" ? window.open(`/editor/allocation-details/${allocationId}`, '_blank') : window.open(`/admin/allocation-details/${allocationId}`, '_blank');
  };


  const OpenEditReport = async (item: any) => {
    try {
      // console.log("Item----->", item)
      const data = {
        ...(item?.reportHeaderId && { reportHeaderId: item?.reportHeaderId }),
        allocationId: item?.allocationId,
        clientGroupName: item?.allocationClientGroup
      }
      const res = await ApiReportTempToken(data)
      if (res.success) {
        sessionStorage.setItem('fromOriginalSite', 'true');
        window.open(`${process.env.REACT_APP_SHOPPER_SITE}?x-z-a=${res?.data?.token}`, '_blank');
      }
      else {
        toast.error(res?.message)
      }
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const scrollToIndex = (_: any, newValue: number | null) => {
    setIndex(newValue);
    if (newValue !== null) {
      itemRefs.current[newValue - 1]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };
  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    allocation: { allocationId: number; userId: number }
  ) => {
    setSelectedAllocations((prev: any) => {
      if (e.target.checked) {
        if (!prev.some((a: any) => a.allocationId === allocation.allocationId)) {
          return [...prev, allocation];
        }
        return prev;
      } else {
        return prev.filter((a: any) => a.allocationId !== allocation.allocationId);
      }
    });
  };


  const handleResetDetails = async () => {
    // setshowdateselect(true)
    try {
      const data = {
        allocations: selectedAllocations,
      }
      const res = await ApiResetBulkAllocation(data)
      toast.success(res.message)
      setSelectedAllocations([])
      handleGetAllocation();
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message)
    }
  }

  const handleUpateDetails = async () => {
    try {
      const data = {
        allocationIds: selectedAllocations.map((item: any) => item.allocationId),
        dateToMove: dayjs(selectedNewDate).date(),
        monthToMove: dayjs(selectedNewDate).month() + 1,
        yearToMove: dayjs(selectedNewDate).year()
      }
      const res = await ApiChangeApproveAllocationsDate(data)
      toast.success("Allocation Moved Successfully.")
      setOpen(false)
      setSelectedAllocations([]);
      handleGetAllocation();
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message)
    }
  }

  const updateAllocationInvoice = async (allocationId: number[], status: boolean) => {
    try {
      const data = {
        allocationIds: allocationId,
        isNeedToDoUnpaid: status
      }
      const res = await ApiUpdateEarlyInvoice(data)
      if (res.status) {
        handleGetAllocation()
        setSelectedAllocations([])
      }
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      toast.error(message)
    }
  }
  console.log("Outsided event", OutsideMonthEvents)

  const formatDuration = (start?: string | Date, end?: string | Date): string => {
    if (!start || !end) return '';
    const diffMs = new Date(end).getTime() - new Date(start).getTime();
    if (Number.isNaN(diffMs) || diffMs < 0) return '';

    const totalSeconds = Math.floor(diffMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (totalSeconds < 60) return `${seconds}s`;
    if (hours === 0) return `${minutes}m`;
    if (minutes === 0) return `${hours}h`;
    return `${hours}h ${minutes}m`;
  };


  return (
    <Box className='w-100 p-2'>
      <div className="border-10 w-100 bg-white p-2 py-3" >
        {/* Status Legend */}
        <Box sx={{ position: { xs: "relative", md: 'sticky' }, top: '0px', zIndex: '1', background: "white" }}>
          <Box
            flexDirection={{ xs: "column", md: 'row' }}
            gap={3}
            sx={{
              display: "flex",
              justifyContent: "space-between", // push items to edges
              alignItems: "center",
              marginBottom: "16px",
            }}
          >
            <Grid container className='d-flex' gap={2}>
              <Grid size={'auto'}>
                <p style={{ fontWeight: 500 }}>Code :</p>
              </Grid>
              <Grid size={'grow'}>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  {[
                    { label: "Approved - Metro", color: "mediumslateblue" },
                    { label: "Approved - Regional", color: "pink" },
                    { label: "CheckedIn", color: "yellow" },
                    { label: "Checkout", color: "green" },
                    { label: "Report Submitted", color: "skyblue" },
                    { label: "Approve to client", color: "purple" },
                    { label: "Report Approved", color: "gray" },
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      style={{
                        backgroundColor: item.color,
                        color: ["yellow", "pink", "hotpink", "skyblue"].includes(
                          item.color
                        )
                          ? "#000"
                          : "#fff",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        fontWeight: 500,
                      }}
                    >
                      {item.label}
                    </div>
                  ))}
                </Box>
              </Grid>
            </Grid>

            <div>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  views={["year", "month"]}
                  openTo="month"
                  label="Select Month"
                  value={selectedDate}
                  onChange={(newValue) => { newValue && setSelectedDate(newValue); dispatch(setDate(newValue)) }}
                  sx={{ width: 250 }}
                />
              </LocalizationProvider>
            </div>
          </Box>

          <Box className="d-flex justify-content-end align-items-center" gap={1}>
            <Button
              variant='contained'
              className='table-row-background'
              onClick={() => {
                const isconfirm = window.confirm("Are you sure you want to mark selected allocations as paid ")
                if (isconfirm) {
                  updateAllocationInvoice(selectedAllocations.map((item: any) => item.allocationId), false)
                }
              }}
            >
              Paid
            </Button>
            <Button
              variant='contained'
              className='table-row-background'
              onClick={() => {
                const isconfirm = window.confirm("Are you sure you want to mark selected allocations as unpaid ")
                if (isconfirm) {
                  updateAllocationInvoice(selectedAllocations.map((item: any) => item.allocationId), true)
                }
              }}
            >
              Unpaid
            </Button>
            <Button
              variant='contained'
              className='table-row-background'
              onClick={() => {
                const isConfirmed = window.confirm("Are You Sure You Want To Reset ?")
                if (isConfirmed) {
                  handleResetDetails()
                }

              }}
            >
              Reset
            </Button>
            <Button
              variant='contained'
              className='table-row-background'
              onClick={() => setOpen(true)}
            >
              Update
            </Button>
          </Box>

          <div
            style={{ display: "flex", justifyContent: "center", margin: "24px 0" }}
          >
            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            views={["year", "month"]}
            label="Select Month"
            value={selectedDate}
            onChange={(newValue) => newValue && setSelectedDate(newValue)}
            sx={{ width: 250 }}
          />
        </LocalizationProvider> */}
          </div>

          <div className="scheduleContainer px-0">
            <div className="scheduleRight-slide px-0">
              <div className="card-container">
                <Box
                  sx={{
                    display: "flex",
                    gap: "16px",
                    width: "100%",
                    flexWrap: { xs: 'wrap', md: 'nowrap' },
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ width: { xs: "100%", md: "30%" } }}>
                    <TextField
                      variant="outlined"
                      placeholder="Search here..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      fullWidth
                      sx={{
                        borderRadius: "10px",
                        "& fieldset": {
                          borderRadius: "10px",
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <img src={Icons.searchNormal || "/placeholder.svg"} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  {/* <div style={{ width: "50%" }}> */}
                  <FormControl fullWidth>
                    <Autocomplete
                      disablePortal
                      options={monthDays.map((_, i) => i + 1)}
                      sx={{ width: { xs: "100%", md: 300 } }}
                      value={index}
                      onChange={scrollToIndex}
                      renderInput={(params) => <TextField {...params} InputLabelProps={{ sx: { opacity: 1, color: "text.primary" }, }} label='Select Date' />}
                    />
                  </FormControl>
                  {/* </div> */}
                  <Box sx={{ display: "flex", flexWrap: { xs: 'wrap', md: "nowrap" }, gap: "16px", width: "100%" }}>
                    <FormControl fullWidth>
                      <Autocomplete
                        // options={Clientlist}
                        options={[...Clientlist, { clientGroupName: "All", clientGroupDBName: "all" }]}
                        value={selectedClient}
                        getOptionLabel={(option: any) =>
                          option?.clientGroupName || ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.clientGroupDBName === value?.clientGroupDBName
                        }
                        // onChange={(event, newValue) => {
                        //   // setSelectedClient(newValue);
                        //   dispatch(setSelectedClientGroup(newValue));
                        //   setClientId(newValue?.clientGroupName || null);

                        //   if (
                        //     !newValue ||
                        //     (selectedClient &&
                        //       newValue.clientGroupName !==
                        //       selectedClient.clientGroupName)
                        //   ) {
                        //     setClientEntityId(null);
                        //     setVenueNameValue(null);
                        //     setClientEntityList([]);
                        //   }
                        // }}
                        onChange={(event, newValue) => {
                          if (newValue?.clientGroupDBName === "all") {
                            // Handle "All" manually without dispatch
                            setSelectedClient(newValue);
                            // setClientId("All");
                            setClientEntityId(null);
                            setVenueNameValue(null);
                            setClientEntityList([]);
                          } else {
                            // Normal case → use dispatch
                            dispatch(setSelectedClientGroup(newValue));
                            setClientId(newValue?.clientGroupName || null);

                            if (
                              !newValue ||
                              (selectedClient &&
                                newValue.clientGroupName !== selectedClient.clientGroupName)
                            ) {
                              setClientEntityId(null);
                              setVenueNameValue(null);
                              setClientEntityList([]);
                              setSelectedRegion(null);
                              setRegions([]);
                            }
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Client"
                            variant="outlined"
                            InputLabelProps={{
                              sx: { color: "text.primary" },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: <>{params.InputProps.endAdornment}</>,
                            }}
                          />
                        )}
                      />
                    </FormControl>

                    <FormControl fullWidth>
                      <Autocomplete
                        disablePortal
                        options={clientEntityList.filter(
                          (item: any) => item.clientEntityId !== null
                        )}
                        getOptionLabel={(option) => option?.entityName || ""}
                        onChange={handleBusinessChange}
                        value={
                          clientEntityList.find(
                            (option: any) => option?.clientEntityId === clientEntityId
                          ) || null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Business"
                            InputLabelProps={{
                              sx: { opacity: 1, color: "text.primary" },
                            }}
                          />
                        )}
                      />
                    </FormControl>

                    {isSpecialClient && (
                      <FormControl fullWidth>
                        <Autocomplete
                          disablePortal
                          options={regions}
                          value={selectedRegion}
                          onChange={(event, newValue: any) => {
                            setSelectedRegion(newValue);
                          }}
                          getOptionLabel={(option) => option.label || ''}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Region"
                              InputLabelProps={{
                                sx: { opacity: 1, color: "text.primary" },
                              }}
                            />
                          )}
                        />
                      </FormControl>

                    )}

                    <FormControl fullWidth>
                      <Autocomplete
                        disablePortal
                        options={venueName}
                        value={
                          venueName.find(
                            (option: any) => option.value === venueNameValue
                          ) || null
                        }
                        onChange={(event, newValue: any) =>
                          setVenueNameValue(newValue?.value)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Site"
                            InputLabelProps={{
                              sx: { opacity: 1, color: "text.primary" },
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </Box>
                </Box>
              </div>
            </div>
          </div>
        </Box>

        <Box className='w-100' overflow='auto'>
          {monthDays.map(({ fullDate, weekday, dayOfMonth, month }, index) => {
            const filteredAllocations = allocations.filter((allocation: any) => {
              const eventDate = new Date(
                allocation?.selectedVisitDate
              );
              const eventDay = eventDate.getDate();
              const eventMonth = eventDate.getMonth();
              const eventYear = eventDate.getFullYear();
              const matchesDate =
                eventDay === dayOfMonth &&
                eventMonth === selectedDate.getMonth() &&
                eventYear === selectedDate.getFullYear();
              const matchesVenueId = venueNameValue
                ? allocation?.venueId?.venueId === venueNameValue
                : true;
              const matchesSearch = search
                ? (allocation?.venueName?.toLowerCase().includes(search.toLowerCase()) ||
                  allocation?.shopperName?.toLowerCase().includes(search.toLowerCase())
                )
                : true;
              return matchesDate && matchesSearch;
            });
            if (filteredAllocations.length === 0) return null;
            return (
              <>
                <Box key={index} ref={(el) => (itemRefs.current[index] = el)} flexDirection={{ xs: "column", md: 'row' }} position={'relative'} className="scheduleContainer">
                  <Box border={'1px solid #cccccc'} className='d-flex flex-column align-items-center justify-content-start' width={'5%'} minWidth={'100px'}>
                    <Typography variant="h2" className="fw-bolder">{dayOfMonth}</Typography>
                    <Typography>{month}</Typography>
                    <Typography>{weekday}</Typography>
                    <br />
                    {/* {weekday} */}
                  </Box>
                  <div className="scheduleRight-slide">
                    <div className="card-container">
                      {filteredAllocations
                        ?.sort((a: any, b: any) => {
                          const clientCompare = a?.clientEntityName?.localeCompare(b?.clientEntityName);
                          if (clientCompare !== 0) return clientCompare;

                          return a?.regionName?.localeCompare(b?.regionName);
                        })
                        .map((allocation: any, i) => {
                          // setFullText(allocation?.shopperNotes)
                          // Determine card color based on reportStatus, checkInDateTime, and checkOutDateTime
                          let cardColor = "#FFF1B3"; // Default color
                          let fontColor = "#fff";

                          if (allocation.reportStatus === "app" || allocation.reportStatus === "rel") {
                            cardColor = 'grey'
                          }
                          else if (allocation.reportStatus === "con") {
                            cardColor = 'skyblue'
                            fontColor = 'black'
                          }
                          else if (allocation.reportStatus === "atc") {
                            cardColor = 'purple'
                            fontColor = 'white'
                          }
                          else {
                            if (allocation?.checkOutDateTime) {
                              cardColor = 'green'
                              fontColor = 'white'
                            }
                            else if (allocation.checkInDateTime) {
                              cardColor = 'yellow'
                              fontColor = 'black'
                            }
                            else if (allocation.locationType === 'region') {
                              cardColor = "pink";
                              fontColor = 'black'
                            }
                            else {
                              cardColor = "mediumslateblue";
                              fontColor = 'white'
                            }
                          }

                          return (
                            <Box
                              key={i}
                              className="event-card  d-flex align-items-end"
                              sx={{
                                position: 'relative',
                                backgroundColor: cardColor,
                                border: "1px solid #CDCDCD",
                                width: { xs: "95%", md: "23%" }
                              }}
                            >
                              <div className="event-info" style={{ width: '100%' }}>
                                <div className="w-100">
                                  <Box justifyContent={'space-between'} className='d-flex mb-1 w-100 align-items-center justify-content-betweeen'>
                                    <div>
                                      {(allocation?.shouldBeDifferentDayFromPreviousMonth === true && dayjs(allocation?.lastJobVisitedDate).format('dddd') === dayjs(allocation?.selectedVisitDate).format('dddd')) ? (
                                        <p className="px-2 d-flex align-items-center gap-1 text-light py-1" style={{ background: 'rgb(246,154,92)', fontSize: "14px", width: 'fit-content', fontWeight: 'bold', borderRadius: '5px' }}><Clear sx={{ fill: 'red' }} />{dayjs(allocation?.selectedVisitDate).format('dddd')}</p>
                                      ) : ''}
                                      {parseInt(allocation?.isNeedToHideWeekend) ? (
                                        <p className="px-2 text-light py-1" style={{ width: 'fit-content', fontSize: "14px", background: 'rgb(246,154,92)', fontWeight: 'bold', borderRadius: '5px' }}>3M ALERT-WKEND</p>
                                      ) : ''}
                                      {parseInt(allocation?.isNeedToHideNonWeekend) ? (
                                        <p className="px-2 text-light py-1" style={{ width: 'fit-content', fontSize: "14px", background: 'rgb(246,154,92)', fontWeight: 'bold', borderRadius: '5px' }}>5M ALERT-WKDAY</p>
                                      ) : ''}
                                    </div>
                                    {(allocation?.sevenDaysAgoVenueOpen && allocation?.threeDaysAfterVenueClose) ? (
                                      <Tooltip title={<Box
                                        component="div"
                                        dangerouslySetInnerHTML={{
                                          __html: `
                                        <p>DO NOT audit or mysteryshop this store between ${dayjs(allocation?.threeDaysAfterVenueClose).format('DD/MM/YYYY') ?? ""} to ${dayjs(allocation?.sevenDaysAgoVenueOpen).format("DD/MM/YYYY") ?? ""} inclusive</p>
                                        <p>${allocation?.venueMessage ?? ""}</p>
                                        `,
                                        }}
                                      />}><IconButton className="m-0 p-0"><img src={venuemessage} height={'24px'} width={'auto'} /></IconButton></Tooltip>
                                    ) : ''}
                                    {(allocation?.venueMessage && !allocation?.sevenDaysAgoVenueOpen && !allocation?.threeDaysAfterVenueClose) ? (
                                      <Tooltip title={<Box
                                        component="div"
                                        dangerouslySetInnerHTML={{
                                          __html: `
                                        <p>${allocation?.venueMessage ?? ""}</p>
                                        `,
                                        }}
                                      />}><IconButton className="m-0 p-0"><img src={venueclose} height={'24px'} width={'auto'} /></IconButton></Tooltip>
                                    ) : ''}
                                    {/* <Tooltip title={"This is title"}><IconButton className="m-0 p-0"><ReportProblemOutlined sx={{ color: 'red' }} /></IconButton></Tooltip> */}
                                  </Box>

                                  <div onClick={() => handleAllocationClick(allocation?.allocationId, allocation?.allocationStatusName)}>
                                    <div className="d-flex align-items-center mt-1 mb-1" style={{ gap: '10px' }}>
                                      <img
                                        src={allocation?.allocationClientGroup === "ALDI" ? aldilogo : allocation?.allocationClientGroup === "BLOOMS" ? bloomslogo : mmlogo}
                                        alt="Company Logo"
                                        className="company-logo p-1 bg-light"
                                        style={{
                                          borderRadius: "50px",
                                          height: "30px",
                                          width: "30px",

                                        }}
                                      />
                                      <p
                                        className="company-name"
                                        style={{ color: fontColor, textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap' }}
                                      >
                                        {allocation?.venueName}{" "}
                                      </p>

                                      {/* <span
                              className="product-name"
                              style={{ color: fontColor, cursor: "pointer" }}
                              onMouseEnter={(e) => {
                                //setLoanData(item);
                                // handleHover(e, i, allocation);

                              }}
                            >
                              | {allocation?.shopperName}
                            </span> */}
                                    </div>
                                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                      <p className="d-flex my-1 align-items-center" style={{ gap: '5px' }}>
                                        {allocation?.shopTypeName && <span className="border px-2 " style={{ borderRadius: '5px', fontSize: '12px', color: fontColor }}>{allocation?.shopTypeName}</span>}
                                        {allocation?.venueCode && <span className="border px-2 " style={{ borderRadius: '5px', fontSize: '12px', color: fontColor }}>{allocation?.venueCode}</span>}
                                        {allocation?.venueGroup && <span className="border px-2 " style={{ borderRadius: '5px', fontSize: '12px', color: fontColor }}>{allocation?.venueGroup}</span>}
                                      </p>
                                      <p style={{ color: fontColor, fontSize: '14px', textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap' }}><strong>E:</strong> {allocation?.editors}</p>
                                    </div>
                                    <p className="mb-1" style={{ color: fontColor, fontSize: '14px', textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap' }}>{allocation?.visitTimeInformation}</p>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="d-flex align-item-center justify-content-between" style={{ gap: "30px", width: "100%" }}>
                                        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                          {allocation?.regionName && (<p className="mb-1 p-1 px-2" style={{ borderRadius: "5px", maxWidth: '', color: fontColor, fontSize: '14px', textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap', background: 'rgb(247,179,42)' }}>{allocation?.regionName}</p>)}
                                          <p className="mb-1 p-1 px-2" style={{ borderRadius: "5px", maxWidth: '', color: fontColor, fontSize: '14px', textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap', background: allocation?.clientEntityName === 'Liquor ID' ? 'rgb(40,137,207)' : "rgb(247,179,42)" }}>{allocation?.clientEntityName}</p>
                                        </div>
                                        <div className="d-flex align-items-center" style={{ gap: '2px' }}>
                                          {!allocation?.profilePicUrl && <img src="https://s3.ap-southeast-2.amazonaws.com/mmfiles-production/ProjectFiles/8a75b1ac-92ff-40eb-a754-35d37728ded3-user-red.png" width="24" height="24" />}
                                          {!allocation?.driving_licence && <img src="https://s3.ap-southeast-2.amazonaws.com/mmfiles-production/ProjectFiles/c5e2aca2-af46-4275-8819-174fa62099f5-driving_licence.png" width="24" height="24" />}
                                          {!allocation?.isLatestAgreementSigned && <img src="https://s3.ap-southeast-2.amazonaws.com/mmfiles-production/ProjectFiles/185be839-3172-427f-a949-f1def383241c-agreement-red.png" width="24" height="24" />}
                                          {(!allocation?.ABNNumber && !allocation?.statementOfsupplier) && <img src="https://s3.ap-southeast-2.amazonaws.com/mmfiles-production/ProjectFiles/5044c342-a64c-43ab-8292-c5dec94565b0-abn-red.png" width="24" height="24" />}
                                        </div>
                                      </div>
                                      {allocation?.isFinalAcceptByShopper ? (<IconButton><img src={clogo} height={'24px'} width={'auto'} /></IconButton>) : ''}
                                    </div>
                                  </div>
                                  <div className="d-flex align-item-center justify-content-between" style={{ gap: "30px" }}>
                                    <div className="d-flex align-items-center" style={{ gap: '5px' }}>
                                      <PersonOutlined sx={{ color: fontColor }} />
                                      <Tooltip
                                        title={
                                          <Box>
                                            {allocation?.shopperNotes && (
                                              <Typography variant="body2">{allocation.shopperNotes}</Typography>
                                            )}
                                            {allocation?.trainingNotes && (
                                              <Typography variant="body2">{allocation.trainingNotes}</Typography>
                                            )}
                                          </Box>
                                        }
                                        arrow
                                      >
                                        <Box className='d-flex align-items-center' sx={{gap:'5px'}}>
                                          <p
                                            className={`event-time ${allocation?.userStatus !== "active" ? "px-2 bg-danger" : ''}`}
                                            style={{ color: fontColor, fontWeight: '800' }}
                                            onClick={(e) => { handleShopperDetailsClick(e, allocation?.userId); setStaticLineInserted(false); }}
                                          >
                                            {allocation?.shopperName}
                                          </p>
                                          <p className="text-white">({formatDuration(allocation.checkInDateTime, allocation.checkOutDateTime)})</p>
                                        </Box>
                                      </Tooltip>
                                      <span className="event-time" style={{ fontWeight: 'bold' }}>{allocation?.userStatus !== "active" && `(${allocation?.userStatus})`}</span>
                                      {(allocation?.isAirTasker === 1 || allocation?.isAirTaskerJob === 1) ? (
                                        <Box
                                          sx={{
                                            backgroundColor: "#2596be",
                                            color: "#fff",
                                            fontSize: "12px",
                                            fontWeight: 600,
                                            px: 1.2,
                                            py: 0.3,
                                            borderRadius: "6px",
                                            display: "inline-block",
                                          }}
                                        >
                                          AIR
                                        </Box>
                                      ) : ""}
                                      {allocation?.isEarlyManualInvoice === 1 &&
                                        <Typography sx={{ backgroundColor: 'black', color: "white", fontWeight: '900', padding: '1px 6px', fontSize: "12px", borderRadius: "50px" }}>$</Typography>}
                                      {Number(allocation.totalReportCountOfShopper) < 2 &&
                                        (<img
                                          height='24px'
                                          src={Number(allocation.totalReportCountOfShopper) === 1 ? new_orange : new_green}
                                        />)}
                                    </div>
                                    <div className="d-flex align-items-center" style={{ gap: '2px' }}>
                                      <Checkbox
                                        className="px-0"
                                        sx={{
                                          color: "#FFFFFF",
                                          "&.Mui-checked": {
                                            color: "#FFFFFF",
                                          },
                                        }}
                                        checked={selectedAllocations.some(
                                          (a: any) => a.allocationId === allocation.allocationId
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChange(e, {
                                            allocationId: allocation.allocationId,
                                            userId: allocation.userId,
                                          })
                                        }
                                      />

                                      {allocation?.isAldiLiquor ? (<IconButton className="m-0 p-0">
                                        <img src={liqur} height={'24px'} width={'auto'} />
                                      </IconButton>) : ''}
                                      <Tooltip title='notes'><IconButton className="m-0 p-0">
                                        <Note onClick={() => { handleOpenNotes(allocation); }} sx={{ color: 'lime' }} height='20px' />
                                      </IconButton></Tooltip>
                                      {allocation?.reportStatus !== null && (
                                        <Tooltip title='edit report'><IconButton className="m-0 p-0" onClick={() => { OpenEditReport(allocation) }}
                                        >
                                          <Edit color={fontColor} height='20px' />
                                        </IconButton></Tooltip>)}

                                    </div>

                                  </div>
                                </div>
                              </div>

                              {showNotes && selectedNotes == allocation.allocationId &&
                                <Box
                                  ref={notesRef}
                                  boxShadow='1px 1px 5px black'
                                  bgcolor='white'
                                  borderRadius='10px'
                                  className='p-1'
                                  minHeight='500px'
                                  position='absolute'
                                  // left='90%'
                                  zIndex={99}
                                  top='10%'
                                  minWidth='500px'
                                  left={openLeft ? 'auto' : '90%'}
                                  right={openLeft ? '0%' : 'auto'}

                                >

                                  <Box className='mt-0 pt-0'>
                                    <Box className='d-flex justify-content-end m-0 p-0'>
                                      <IconButton onClick={() => { setshowNotes(false); setselectedNotes(0); setOpenLeft(null) }}><CancelOutlined /></IconButton>
                                    </Box>
                                    <Box className='mb-2'>
                                      <Typography variant="h6" fontWeight='bold' bgcolor='#75724C' className="py-1 text-center text-light">Shopper Notes</Typography>
                                      <Box className='p-1'>
                                        <textarea
                                          className="border-0"
                                          value={fullText}
                                          ref={shoppernoteRef}
                                          onFocus={handleOnFocus}
                                          onChange={handleChange}

                                          rows={8}
                                          style={{
                                            width: '100%',
                                            boxShadow: '1px 1px 3px black',
                                            fontSize: '14px',
                                            padding: '8px',
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                    <Box>
                                      <Typography variant="h6" fontWeight='bold' bgcolor='#75724C' className="py-1 text-center text-light">Training Notes</Typography>
                                      <Box className='p-1'>
                                        <textarea
                                          className="border-0"
                                          ref={trainingnoteRef}
                                          value={fullText2}
                                          onFocus={handleOnFocus2}
                                          onChange={handleChangetraining}

                                          rows={8}
                                          style={{
                                            width: '100%',
                                            boxShadow: '1px 1px 3px black',
                                            fontSize: '14px',
                                            padding: '8px',
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                    <Box className='d-flex justify-content-center my-3'>
                                      <Button className="py-1 px-4" onClick={() => { saveNotes(allocation?.userId) }} sx={{ backgroundColor: '#75724C', color: 'white' }}>Save</Button>
                                    </Box>
                                  </Box>
                                </Box>}
                            </Box>
                          );
                        })}
                      <Popover
                        open={Boolean(anchorEl) && selectedIndex === index}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                      >
                        <Dcrage handleClose={handleClose} loanData={loanData} />
                      </Popover>

                    </div>
                  </div>
                </Box>

              </>
            );
          })}
        </Box>


        <Box className='w-100' overflow='auto'>
          {OutsideMonthEvents.length > 0 && (
            <Box className="mt-3 p-3 bg-light border rounded">
              <Typography variant="h5" className="fw-bold mb-3">
                {/* Not in this month */}
                Applied date not matched with current month
              </Typography>

              <div className="card-container">
                {OutsideMonthEvents
                  // ?.filter((item:any)=>)
                  ?.sort((a: any, b: any) => {
                    const clientCompare = a?.clientEntityName?.localeCompare(b?.clientEntityName);
                    if (clientCompare !== 0) return clientCompare;

                    return a?.regionName?.localeCompare(b?.regionName);
                  })
                  .map((allocation: any, i) => {
                    // setFullText(allocation?.shopperNotes)
                    // Determine card color based on reportStatus, checkInDateTime, and checkOutDateTime
                    let cardColor = "#FFF1B3"; // Default color
                    let fontColor = "#fff";

                    if (allocation.reportStatus === "app" || allocation.reportStatus === "rel") {
                      cardColor = 'grey'
                    }
                    else if (allocation.reportStatus === "con") {
                      cardColor = 'skyblue'
                      fontColor = 'black'
                    }
                    else if (allocation.reportStatus === "atc") {
                      cardColor = 'purple'
                      fontColor = 'white'
                    }
                    else {
                      if (allocation?.checkOutDateTime) {
                        cardColor = 'green'
                        fontColor = 'white'
                      }
                      else if (allocation.checkInDateTime) {
                        cardColor = 'yellow'
                        fontColor = 'black'
                      }
                      else if (allocation.locationType === 'region') {
                        cardColor = "pink";
                        fontColor = 'black'
                      }
                      else {
                        cardColor = "mediumslateblue";
                        fontColor = 'white'
                      }
                    }

                    return (
                      <Box
                        key={i}
                        className="event-card  d-flex align-items-end"
                        sx={{
                          position: 'relative',
                          backgroundColor: cardColor,
                          border: "1px solid #CDCDCD",
                          width: { xs: "95%", md: "23%" }
                        }}
                      >
                        <div className="event-info" style={{ width: '100%' }}>
                          <div className="w-100">
                            <Box justifyContent={'space-between'} className='d-flex mb-1 w-100 align-items-center justify-content-betweeen'>
                              <div>
                                {(allocation?.shouldBeDifferentDayFromPreviousMonth === true && dayjs(allocation?.lastJobVisitedDate).format('dddd') === dayjs(allocation?.selectedVisitDate).format('dddd')) ? (
                                  <p className="px-2 d-flex align-items-center gap-1 text-light py-1" style={{ background: 'rgb(246,154,92)', fontSize: "14px", width: 'fit-content', fontWeight: 'bold', borderRadius: '5px' }}><Clear sx={{ fill: 'red' }} />{dayjs(allocation?.selectedVisitDate).format('dddd')}</p>
                                ) : ''}
                                {parseInt(allocation?.isNeedToHideWeekend) ? (
                                  <p className="px-2 text-light py-1" style={{ width: 'fit-content', fontSize: "14px", background: 'rgb(246,154,92)', fontWeight: 'bold', borderRadius: '5px' }}>3M ALERT-WKEND</p>
                                ) : ''}
                                {parseInt(allocation?.isNeedToHideNonWeekend) ? (
                                  <p className="px-2 text-light py-1" style={{ width: 'fit-content', fontSize: "14px", background: 'rgb(246,154,92)', fontWeight: 'bold', borderRadius: '5px' }}>5M ALERT-WKDAY</p>
                                ) : ''}
                              </div>
                              {(allocation?.sevenDaysAgoVenueOpen && allocation?.threeDaysAfterVenueClose) ? (
                                <Tooltip title={<Box
                                  component="div"
                                  dangerouslySetInnerHTML={{
                                    __html: `
                                        <p>DO NOT audit or mysteryshop this store between ${dayjs(allocation?.threeDaysAfterVenueClose).format('DD/MM/YYYY') ?? ""} and ${dayjs(allocation?.sevenDaysAgoVenueOpen).format("DD/MM/YYYY") ?? ""}</p>
                                        <p>${allocation?.venueMessage ?? ""}</p>
                                        `,
                                  }}
                                />}><IconButton className="m-0 p-0"><img src={venuemessage} height={'24px'} width={'auto'} /></IconButton></Tooltip>
                              ) : ''}
                              {(allocation?.venueMessage && !allocation?.sevenDaysAgoVenueOpen && !allocation?.threeDaysAfterVenueClose) ? (
                                <Tooltip title={<Box
                                  component="div"
                                  dangerouslySetInnerHTML={{
                                    __html: `
                                        <p>${allocation?.venueMessage ?? ""}</p>
                                        `,
                                  }}
                                />}><IconButton className="m-0 p-0"><img src={venueclose} height={'24px'} width={'auto'} /></IconButton></Tooltip>
                              ) : ''}
                              {/* <Tooltip title={"This is title"}><IconButton className="m-0 p-0"><ReportProblemOutlined sx={{ color: 'red' }} /></IconButton></Tooltip> */}
                            </Box>

                            <div onClick={() => handleAllocationClick(allocation?.allocationId, allocation?.allocationStatusName)}>
                              <div className="d-flex align-items-center mt-1 mb-1" style={{ gap: '10px' }}>
                                <img
                                  src={allocation?.allocationClientGroup === "ALDI" ? aldilogo : allocation?.allocationClientGroup === "BLOOMS" ? bloomslogo : mmlogo}
                                  alt="Company Logo"
                                  className="company-logo p-1 bg-light"
                                  style={{
                                    borderRadius: "50px",
                                    height: "30px",
                                    width: "30px",

                                  }}
                                />
                                <p
                                  className="company-name"
                                  style={{ color: fontColor, textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap' }}
                                >
                                  {allocation?.venueName}{" "}
                                </p>

                                {/* <span
                              className="product-name"
                              style={{ color: fontColor, cursor: "pointer" }}
                              onMouseEnter={(e) => {
                                //setLoanData(item);
                                // handleHover(e, i, allocation);

                              }}
                            >
                              | {allocation?.shopperName}
                            </span> */}
                              </div>
                              <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                <p className="d-flex my-1 align-items-center" style={{ gap: '5px' }}>
                                  {allocation?.shopTypeName && <span className="border px-2 " style={{ borderRadius: '5px', fontSize: '12px', color: fontColor }}>{allocation?.shopTypeName}</span>}
                                  {allocation?.venueCode && <span className="border px-2 " style={{ borderRadius: '5px', fontSize: '12px', color: fontColor }}>{allocation?.venueCode}</span>}
                                  {allocation?.venueGroup && <span className="border px-2 " style={{ borderRadius: '5px', fontSize: '12px', color: fontColor }}>{allocation?.venueGroup}</span>}
                                </p>
                                <p style={{ color: fontColor, fontSize: '14px', textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap' }}><strong>E:</strong> {allocation?.editors}</p>
                              </div>
                              <p className="mb-1" style={{ color: fontColor, fontSize: '14px', textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap' }}>{allocation?.visitTimeInformation}</p>
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-item-center justify-content-between" style={{ gap: "30px", width: "100%" }}>
                                  <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                    {allocation?.regionName && (<p className="mb-1 p-1 px-2" style={{ borderRadius: "5px", maxWidth: '', color: fontColor, fontSize: '14px', textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap', background: 'rgb(247,179,42)' }}>{allocation?.regionName}</p>)}
                                    <p className="mb-1 p-1 px-2" style={{ borderRadius: "5px", maxWidth: '', color: fontColor, fontSize: '14px', textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap', background: allocation?.clientEntityName === 'Liquor ID' ? 'rgb(40,137,207)' : "rgb(247,179,42)" }}>{allocation?.clientEntityName}</p>
                                  </div>
                                  <div className="d-flex align-items-center" style={{ gap: '2px' }}>
                                    {!allocation?.profilePicUrl && <img src="https://s3.ap-southeast-2.amazonaws.com/mmfiles-production/ProjectFiles/8a75b1ac-92ff-40eb-a754-35d37728ded3-user-red.png" width="24" height="24" />}
                                    {!allocation?.driving_licence && <img src="https://s3.ap-southeast-2.amazonaws.com/mmfiles-production/ProjectFiles/c5e2aca2-af46-4275-8819-174fa62099f5-driving_licence.png" width="24" height="24" />}
                                    {!allocation?.isLatestAgreementSigned && <img src="https://s3.ap-southeast-2.amazonaws.com/mmfiles-production/ProjectFiles/185be839-3172-427f-a949-f1def383241c-agreement-red.png" width="24" height="24" />}
                                    {(!allocation?.ABNNumber && !allocation?.statementOfsupplier) && <img src="https://s3.ap-southeast-2.amazonaws.com/mmfiles-production/ProjectFiles/5044c342-a64c-43ab-8292-c5dec94565b0-abn-red.png" width="24" height="24" />}
                                  </div>
                                </div>
                                {allocation?.isFinalAcceptByShopper ? (<IconButton><img src={clogo} height={'24px'} width={'auto'} /></IconButton>) : ''}
                              </div>
                            </div>
                            <div className="d-flex align-item-center justify-content-between" style={{ gap: "30px" }}>
                              <div className="d-flex align-items-center" style={{ gap: '5px' }}>
                                <PersonOutlined sx={{ color: fontColor }} />
                                <Tooltip
                                  title={
                                    <Box>
                                      {allocation?.shopperNotes && (
                                        <Typography variant="body2">{allocation.shopperNotes}</Typography>
                                      )}
                                      {allocation?.trainingNotes && (
                                        <Typography variant="body2">{allocation.trainingNotes}</Typography>
                                      )}
                                    </Box>
                                  }
                                  arrow
                                >
                                  <p
                                    className="event-time"
                                    style={{ color: fontColor }}
                                    onClick={(e) => { handleShopperDetailsClick(e, allocation?.userId); setStaticLineInserted(false); }}
                                  >
                                    {
                                      allocation?.shopperName
                                    }
                                  </p> </Tooltip>
                                {(allocation?.isAirTasker === 1 || allocation?.isAirTaskerJob === 1) ? (
                                  <Box
                                    sx={{
                                      backgroundColor: "#2596be",
                                      color: "#fff",
                                      fontSize: "12px",
                                      fontWeight: 600,
                                      px: 1.2,
                                      py: 0.3,
                                      borderRadius: "6px",
                                      display: "inline-block",
                                    }}
                                  >
                                    AIR
                                  </Box>
                                ) : ""}
                                {allocation?.isEarlyManualInvoice === 1 &&
                                  <Typography sx={{ backgroundColor: 'black', color: "white", fontWeight: '900', padding: '1px 6px', fontSize: "12px", borderRadius: "50px" }}>$</Typography>}
                                {Number(allocation.totalReportCountOfShopper) < 2 &&
                                  (<img
                                    height='20px'
                                    src={Number(allocation.totalReportCountOfShopper) === 1 ? new_green : new_green}
                                  />)}
                              </div>
                              <div className="d-flex align-items-center" style={{ gap: '2px' }}>
                                <Checkbox
                                  className="px-0"
                                  sx={{
                                    color: "#FFFFFF",
                                    "&.Mui-checked": {
                                      color: "#FFFFFF",
                                    },
                                  }}
                                  checked={selectedAllocations.some(
                                    (a: any) => a.allocationId === allocation.allocationId
                                  )}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, {
                                      allocationId: allocation.allocationId,
                                      userId: allocation.userId,
                                    })
                                  }
                                />

                                {allocation?.isAldiLiquor ? (<IconButton className="m-0 p-0">
                                  <img src={liqur} height={'24px'} width={'auto'} />
                                </IconButton>) : ''}
                                <Tooltip title='notes'><IconButton className="m-0 p-0">
                                  <Note onClick={() => { handleOpenNotes(allocation); }} sx={{ color: 'lime' }} height='20px' />
                                </IconButton></Tooltip>
                                {allocation?.reportStatus !== null && (
                                  <Tooltip title='edit report'><IconButton className="m-0 p-0" onClick={() => { OpenEditReport(allocation) }}
                                  >
                                    <Edit color={fontColor} height='20px' />
                                  </IconButton></Tooltip>)}

                              </div>

                            </div>
                          </div>
                        </div>

                        {showNotes && selectedNotes == allocation.allocationId &&
                          <Box
                            boxShadow='1px 1px 5px black'
                            bgcolor='white'
                            borderRadius='10px'
                            className='p-1'
                            minHeight='500px'
                            position='absolute'
                            left='90%'
                            zIndex={99}
                            top='10%'
                            minWidth='500px'
                          >

                            <Box className='mt-0 pt-0'>
                              <Box className='d-flex justify-content-end m-0 p-0'>
                                <IconButton onClick={() => { setshowNotes(false); setselectedNotes(0) }}><CancelOutlined /></IconButton>
                              </Box>
                              <Box className='mb-2'>
                                <Typography variant="h6" fontWeight='bold' bgcolor='#75724C' className="py-1 text-center text-light">Shopper Notes</Typography>
                                <Box className='p-1'>
                                  <textarea
                                    className="border-0"
                                    value={fullText}
                                    ref={shoppernoteRef}
                                    onFocus={handleOnFocus}
                                    onChange={handleChange}

                                    rows={8}
                                    style={{
                                      width: '100%',
                                      boxShadow: '1px 1px 3px black',
                                      fontSize: '14px',
                                      padding: '8px',
                                    }}
                                  />
                                </Box>
                              </Box>
                              <Box>
                                <Typography variant="h6" fontWeight='bold' bgcolor='#75724C' className="py-1 text-center text-light">Training Notes</Typography>
                                <Box className='p-1'>
                                  <textarea
                                    className="border-0"
                                    ref={trainingnoteRef}
                                    value={fullText2}
                                    onFocus={handleOnFocus2}
                                    onChange={handleChangetraining}

                                    rows={8}
                                    style={{
                                      width: '100%',
                                      boxShadow: '1px 1px 3px black',
                                      fontSize: '14px',
                                      padding: '8px',
                                    }}
                                  />
                                </Box>
                              </Box>
                              <Box className='d-flex justify-content-center my-3'>
                                <Button className="py-1 px-4" onClick={() => { saveNotes(allocation?.userId) }} sx={{ backgroundColor: '#75724C', color: 'white' }}>Save</Button>
                              </Box>
                            </Box>
                          </Box>}
                      </Box>
                    );
                  })}
                <Popover
                  open={Boolean(anchorEl) && selectedIndex === index}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  <Dcrage handleClose={handleClose} loanData={loanData} />
                </Popover>

              </div>
            </Box>
          )
          }
        </Box>


        {allocations.length === 0 && (
          <p style={{ textAlign: "center", padding: "2rem" }}>
            No events found for selected filters.
          </p>
        )}
        <Popover
          open={Boolean(anchorEl) && clickedShopperId !== null}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Dcrage handleClose={handleClose} loanData={loanData} />
        </Popover>
        {isStartLoading && (
          <div
            className="loader-overlay"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              // background: 'rgba(0, 0, 0, 0.8)',
              zIndex: 9999,
            }}
          >
            <div
              style={{
                border: '4px solid rgba(103, 107, 65, 1)',
                borderRadius: '50%',
                borderTop: '4px solid white',
                width: 35,
                height: 35,
                animation: 'spin 0.6s linear infinite',
              }}
            ></div>

            {/* Add animation style manually */}
            <style>
              {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
            </style>
          </div>
        )}
        <Dialog open={open}>
          <DialogContent>
            <Box className='d-flex align-items-center justify-content-end'>
              <IconButton onClick={() => { setOpen(false) }}><CancelOutlined /></IconButton>
            </Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                minDate={dayjs(selectedDate).startOf("month")}
                maxDate={dayjs(selectedDate).endOf("month")}
                value={selectedNewDate}
                //    views={["month", "year"]}   
                onChange={(newValue) => setSelectedNewDate(newValue)}
              />
            </LocalizationProvider>
            <Box className='d-flex align-items-center justify-content-center'>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className="table-row-background"
                onClick={() => { handleUpateDetails() }}
              >Update</Button>
            </Box>
          </DialogContent>
        </Dialog>
      </div>
    </Box>
  );
};

export default MonthlyCalendar;
